export default __webpack_public_path__ + "static/media/logo_delectable.6d958d4f.png";